export default "__VITE_ASSET__ddb85e81__"